import { Link } from "react-router-dom";

export default function SafetyBanner() {
  return (
    <section className="my-12" data-testid="safety-banner">
      <div className="rounded-3xl bg-stone-50 border border-stone-200 overflow-hidden grid md:grid-cols-[260px_1fr_auto] items-center gap-6 p-6">
        <div className="rounded-2xl overflow-hidden aspect-[3/4] md:aspect-square h-full max-h-64 md:max-h-none">
          <img
            src="https://images.unsplash.com/photo-1775649135495-5d129f2fdc2e?w=800&q=80"
            alt="Waterfall canyon"
            className="w-full h-full object-cover"
            onError={(e) => { e.target.src = "https://images.unsplash.com/photo-1469125155630-7ed37e065743?w=800&q=80"; }}
          />
        </div>
        <div className="py-2">
          <span className="inline-block text-xs font-semibold uppercase tracking-wider text-amber-700 bg-amber-100 rounded-full px-3 py-1 mb-3">
            Safety first
          </span>
          <h3 className="text-2xl md:text-3xl font-extrabold tracking-tight text-stone-900">
            Stay safe at every waterfall
          </h3>
          <p className="mt-2 text-stone-700 max-w-xl leading-relaxed">
            Wet rocks, hidden currents and fast-changing weather catch out experienced hikers every year. Read our quick safety guide before you head out.
          </p>
        </div>
        <Link
          to="/safety"
          data-testid="safety-banner-cta"
          className="btn-at border-2 border-stone-900 text-stone-900 hover:bg-stone-900 hover:text-white !rounded-full !px-7 self-end md:self-center mr-0 md:mr-4"
        >
          Read safety tips
        </Link>
      </div>
    </section>
  );
}
